import "../../../assets/RideErrorMessage.css";
import o from "clsx";
import e from "react";
import { RideGlWarningCircleSolid as i } from "../graphic/glyph/components/RideGlWarningCircleSolid.js";
const l = "_message_wjy6m_9", r = {
  "ride-error-message": "_ride-error-message_wjy6m_1",
  message: l
};
function p({
  className: s,
  message: t = "Error Message",
  "data-testid": a
}) {
  const m = () => o(s, r["ride-error-message"]);
  return /* @__PURE__ */ e.createElement("div", { "data-testid": a, className: m() }, /* @__PURE__ */ e.createElement(i, { size: "medium", fill: "currentColor" }), /* @__PURE__ */ e.createElement("p", { className: r.message, role: "alert" }, t));
}
export {
  p as RideErrorMessage
};
